import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getEmployeeEntriesSelector = createSelector(
  employeeEntries => employeeEntries.employeeEntries,
  (employeeEntriesById) => getArrayOfObjectValues(employeeEntriesById)
);